import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsented = localStorage.getItem('cookie-consent');
    if (!hasConsented) {
      // Show consent banner after a brief delay
      const timer = setTimeout(() => setShowConsent(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:left-6 sm:right-auto sm:max-w-md">
      <Card className="glass-morphism-dark p-4 shadow-xl border border-border/50">
        <div className="flex items-start gap-3">
          <Cookie className="h-5 w-5 text-accent mt-0.5 flex-shrink-0" />
          <div className="flex-1 space-y-3">
            <div>
              <h3 className="font-medium text-foreground text-sm">
                We use cookies
              </h3>
              <p className="text-muted-foreground text-xs mt-1">
                We use essential cookies for authentication and optional analytics cookies to improve your experience.
              </p>
            </div>
            
            <div className="flex gap-2 text-xs">
              <Button
                onClick={acceptCookies}
                size="sm"
                className="h-7 px-3 text-xs"
              >
                Accept All
              </Button>
              <Button
                onClick={declineCookies}
                variant="outline"
                size="sm"
                className="h-7 px-3 text-xs"
              >
                Essential Only
              </Button>
            </div>
          </div>
          
          <Button
            onClick={declineCookies}
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 hover:bg-secondary/20"
          >
            <X className="h-3 w-3" />
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsent;